document.addEventListener("DOMContentLoaded", () => {
  const checkoutBtn = document.getElementById('checkout');
  if (!checkoutBtn) return;

   checkoutBtn.addEventListener('click', () => {
     fetch('/cart.js')
       .then(res => res.json())
       .then(cart => {
         if (!cart.items || cart.items.length === 0) return;

         const orderData = {
          items: cart.items.map(item => ({
             id: item.variant_id,
             title: item.title,
             variant: item.variant_title,
             quantity: item.quantity,
             price: item.price / 100,
             image: item.image || ''
           })),
           subtotal: cart.items_subtotal_price / 100,
           shippingCost: 0.0,
           tax: 0.0,
           total: cart.total_price / 100,
            store_logo: "",
            store_domain: window.location.origin,
            store_currency:window.Shopify.currency.active,
         };
         //console.log(orderData) 
         const orderInfo = btoa(unescape(encodeURIComponent(JSON.stringify(orderData))));
         window.location.href = `https://cart.mikasalife.us?orderInfo=${encodeURIComponent(orderInfo)}`;
       });
   });
});

document.addEventListener('click', (e) => {
    // 拦截弹窗 checkout 按钮
    const checkoutBtn = e.target.closest('form#cart-notification-form button[name="checkout"]');
    if (!checkoutBtn) return;

    e.preventDefault(); // 阻止 Shopify 默认跳转

    // 读取当前购物车
    fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
            if (!cart.items || cart.items.length === 0) return;

            const orderData = {
                items: cart.items.map(item => ({
                    id: item.variant_id,
                    title: item.title,
                    variant: item.variant_title,
                    quantity: item.quantity,
                    price: item.price / 100,
                    image: item.image || ''
                })),
                subtotal: cart.items_subtotal_price / 100,
                shippingCost: 0.0,
                tax: 0.0,
                total: cart.total_price / 100,
                store_logo: "",
                store_domain: window.location.origin,
                store_currency:window.Shopify.currency.active,
            };
            //console.log(orderData)
            const orderInfo = btoa(unescape(encodeURIComponent(JSON.stringify(orderData))));
            window.location.href = `https://cart.mikasalife.us?orderInfo=${encodeURIComponent(orderInfo)}`;
        });
});
